(() => {
  const storageKey = 'zoghoo-size-chart-unit';

  function initialise(root) {
    if (root.dataset.zghUnitsReady === 'true') return;
    const toolbar = root.querySelector('[data-zgh-unit-toolbar]');
    if (!toolbar) return;
    root.dataset.zghUnitsReady = 'true';

    function setUnit(unit) {
      const metric = unit !== 'in';
      const dataKey = metric ? 'zghCm' : 'zghIn';
      root.querySelectorAll('[data-zgh-cm][data-zgh-in]').forEach(node => {
        node.textContent = node.dataset[dataKey];
      });
      toolbar.querySelectorAll('[data-zgh-set-unit]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.zghSetUnit === (metric ? 'cm' : 'in')));
      });
      const status = toolbar.querySelector('[data-zgh-unit-status]');
      if (status) status.textContent = metric ? 'Measurements in centimeters · weight in kg' : 'Measurements in inches · weight in lb';
      root.dataset.zghCurrentUnit = metric ? 'cm' : 'in';
    }

    let preferred = 'cm';
    try { preferred = localStorage.getItem(storageKey) === 'in' ? 'in' : 'cm'; } catch (_) { /* Storage is optional. */ }
    setUnit(preferred);
    toolbar.hidden = false;
    toolbar.addEventListener('click', event => {
      const button = event.target.closest('[data-zgh-set-unit]');
      if (!button || !toolbar.contains(button)) return;
      const unit = button.dataset.zghSetUnit;
      setUnit(unit);
      try { localStorage.setItem(storageKey, unit); } catch (_) { /* The switch also works without storage. */ }
    });
  }

  const scan = () => document.querySelectorAll('.zgh-size-chart-content').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
